<div class="px-3 pt-3 card-box mb-3">
  <div class="form-row">
    <div class="col-12 col-md-8">
      <app-control-wrapper [control]="formGroup.get('displayName')" [errors]="errors">
        <label for="voyage-displayName" control-label>
          {{ "LABELS.NAME" | translate }}
          <i class="fa fa-asterisk form-required" aria-hidden="true"></i>
        </label>
        <input
          control-wrapper
          type="text"
          [formControl]="formGroup.get('displayName')"
          class="form-control"
          id="voyage-displayName"
          name="voyage-displayName"
          [mask]="'F*'"
          [dropSpecialCharacters]="false"
          [patterns]="CUSTOM_MASK"
          [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
        />
      </app-control-wrapper>
    </div>

    <div class="col-12 col-md-4">
      <date-picker
        [label]="'FORM_LABEL.VALIDITY_DATE'"
        [fc]="formGroup.get('validityDate')"
        [id]="'voyage-validityDate'"
        [name]="'voyage-validityDate'"
        [required]="false"
      ></date-picker>
    </div>

    <div class="col-12 col-md-6">
      <app-control-wrapper [control]="formGroup.get('status')" [errors]="errors">
        <label for="voyage-status" control-label>
          {{ "LABELS.STATUS" | translate }}
          <i class="fa fa-asterisk form-required" aria-hidden="true"></i>
        </label>
        <ng-select
          class="custom"
          [formControl]="formGroup.get('status')"
          control-wrapper
          [placeholder]="'FORM_PLACEHOLDER.SELECT' | translate"
          bindLabel="label"
          bindValue="value"
          [items]="statusSelect"
          id="voyage-status"
        ></ng-select>
      </app-control-wrapper>
    </div>

    <div class="col-12 col-md-6">
      <app-control-wrapper [control]="formGroup.get('publishingState')" [errors]="errors">
        <label for="voyage-publishingState" control-label>
          {{ "LABELS.PUBLISHING_STATE" | translate }}
          <i class="fa fa-asterisk form-required" aria-hidden="true"></i>
        </label>
        <ng-select
          class="custom"
          [formControl]="formGroup.get('publishingState')"
          control-wrapper
          [placeholder]="'FORM_PLACEHOLDER.SELECT' | translate"
          bindLabel="label"
          bindValue="value"
          [items]="publishingStateSelect"
          id="voyage-publishingState"
        ></ng-select>
      </app-control-wrapper>
    </div>
  </div>
</div>

<div class="px-3 pt-3 card-box mb-3">
  <div class="form-row">
    <div class="col-12 header mb-2">
      {{ "LABELS.ESTIMATED_INFORMATION" | translate }}
    </div>
    <div class="col-12 col-md-6">
      <date-picker
        [label]="'LABELS.ESTIMATED_TIME_OF_DEPARTURE'"
        [fc]="formGroup.get('estimatedDepartureTime')"
        [id]="'voyage-estimatedDepartureTime'"
        [name]="'voyage-estimatedDepartureTime'"
        [showCurrentDate]="true"
        [required]="true"
      ></date-picker>
    </div>
    <div class="col-12 col-md-6">
      <date-picker
        [label]="'LABELS.ESTIMATED_TIME_OF_ARRIVAL'"
        [fc]="formGroup.get('estimatedArrivalTime')"
        [id]="'voyage-estimatedArrivalTime'"
        [name]="'voyage-estimatedArrivalTime'"
        [showCurrentDate]="true"
        [required]="true"
      ></date-picker>
    </div>
    <div class="col-12">
      <app-control-wrapper [control]="formGroup.get('estimatedDuration')" [errors]="errors">
        <label for="voyage-estimatedDuration" control-label>
          {{ "FORM_LABEL.ESTIMATED_DURATION" | translate }}
          <i class="fa fa-asterisk form-required" aria-hidden="true"></i>
        </label>
        <input
          control-wrapper
          type="text"
          [formControl]="formGroup.get('estimatedDuration')"
          class="form-control"
          id="voyage-estimatedDuration"
          name="voyage-estimatedDuration"
          [mask]="'0*'"
          [dropSpecialCharacters]="false"
          [patterns]="CUSTOM_MASK"
          [appMaskErrorTooltip]="'MASK_ERROR.ONLY_DIGITS'"
        />
      </app-control-wrapper>
    </div>
  </div>
</div>

<div class="px-3 pt-3 card-box mb-3">
  <div class="form-row">
    <div class="col-12 header mb-2">
      {{ "LABELS.ACTUAL_INFORMATION" | translate }}
    </div>
    <div class="col-12 col-md-6">
      <date-picker
        [label]="'LABELS.ACTUAL_TIME_OF_DEPARTURE'"
        [fc]="formGroup.get('actualDepartureTime')"
        [id]="'voyage-actualDepartureTime'"
        [name]="'voyage-actualDepartureTime'"
        [showCurrentDate]="true"
      ></date-picker>
    </div>
    <div class="col-12 col-md-6">
      <date-picker
        [label]="'LABELS.ACTUAL_TIME_OF_ARRIVAL'"
        [fc]="formGroup.get('actualArrivalTime')"
        [id]="'voyage-actualArrivalTime'"
        [name]="'voyage-actualArrivalTime'"
        [showCurrentDate]="true"
      ></date-picker>
    </div>
  </div>
</div>

<div class="px-3 pt-3 card-box mb-3">
  <div class="form-row">
    <div class="col-12 header mb-2">
      {{ "MENU.CFS" | translate }}
    </div>
  </div>
</div>

<div class="px-3 pt-3 card-box">
  <div class="form-row">
    <div class="col-12 header mb-2">
      {{ "LABELS.PREPARATION_CUTOFF" | translate }}
    </div>
    <div class="col-12 col-md-4">
      <date-picker
        [label]="'LABELS.CONTAINER_PREPARATION_CUTOFF'"
        [fc]="formGroup.get('containerCutoff')"
        [id]="'voyage-containerCutoff'"
        [name]="'voyage-containerCutoff'"
        [showCurrentDate]="true"
        [required]="true"
      ></date-picker>
    </div>

    <div class="col-12 col-md-4">
      <date-picker
        [label]="'LABELS.DOCUMENTS_PREPARATION_CUTOFF'"
        [fc]="formGroup.get('documentsCutoff')"
        [id]="'voyage-documentsCutoff'"
        [name]="'voyage-documentsCutoff'"
        [showCurrentDate]="true"
        [required]="true"
      ></date-picker>
    </div>

    <div class="col-12 col-md-4">
      <date-picker
        [label]="'LABELS.WAREHOUSE_PREPARATION_CUTOFF'"
        [fc]="formGroup.get('warehouseCutoff')"
        [id]="'voyage-warehouseCutoff'"
        [name]="'voyage-warehouseCutoff'"
        [showCurrentDate]="true"
        [required]="true"
      ></date-picker>
    </div>
  </div>
</div>
